import styled from "styled-components";

export const PageContainer = styled.div`
  max-width: 100%;
  margin: 40px auto;
  padding: 0 20px;

  @media (max-width: 768px) {
    margin: 20px auto;
    padding: 0 12px;
  }

  @media (max-width: 480px) {
    margin: 15px auto;
    padding: 0 8px;
  }
`;

export const Header = styled.div`
  background: linear-gradient(135deg, #203b34 0%, #2d5245 100%);
  border-radius: 16px;
  padding: 32px;
  margin-bottom: 30px;
  box-shadow: 0 4px 16px rgba(32, 59, 52, 0.2);

  @media (max-width: 1024px) {
    padding: 24px;
    margin-bottom: 24px;
  }

  @media (max-width: 768px) {
    padding: 16px;
    margin-bottom: 16px;
    border-radius: 12px;
  }

  @media (max-width: 480px) {
    padding: 12px;
    margin-bottom: 12px;
    border-radius: 8px;
  }
`;

export const HeaderTop = styled.div`
  display: flex;
  align-items: center;
  gap: 20px;
  margin-bottom: 24px;
  flex-wrap: wrap;

  @media (max-width: 1024px) {
    gap: 16px;
    margin-bottom: 20px;
  }

  @media (max-width: 768px) {
    gap: 12px;
    margin-bottom: 16px;
  }

  @media (max-width: 480px) {
    gap: 10px;
    margin-bottom: 12px;
  }
`;

export const CourseIcon = styled.div`
  width: 60px;
  height: 60px;
  background: ${(props) => (props.$completed ? "#10b981" : "#f9ae17")};
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 28px;
  color: white;
  flex-shrink: 0;

  @media (max-width: 768px) {
    width: 50px;
    height: 50px;
    font-size: 24px;
    border-radius: 8px;
  }

  @media (max-width: 480px) {
    width: 40px;
    height: 40px;
    font-size: 20px;
    border-radius: 6px;
  }
`;

export const HeaderContent = styled.div`
  flex: 1;
  min-width: 150px;

  @media (max-width: 768px) {
    flex: 1 1 auto;
  }

  @media (max-width: 480px) {
    flex: 1 1 auto;
  }
`;

export const Title = styled.h1`
  color: white;
  font-size: 28px;
  font-weight: 700;
  margin: 0 0 8px 0;
  word-break: break-word;
  line-height: 1.3;

  @media (max-width: 1024px) {
    font-size: 24px;
  }

  @media (max-width: 768px) {
    font-size: 18px;
    margin-bottom: 4px;
  }

  @media (max-width: 480px) {
    font-size: 16px;
    margin-bottom: 2px;
  }
`;

export const Subtitle = styled.p`
  color: rgba(255, 255, 255, 0.85);
  font-size: 15px;
  margin: 0;

  @media (max-width: 768px) {
    font-size: 13px;
  }

  @media (max-width: 480px) {
    font-size: 12px;
  }
`;

export const StatusBadge = styled.span`
  background: ${(props) => (props.$completed ? "#10b981" : "#f9ae17")};
  color: white;
  padding: 8px 16px;
  border-radius: 20px;
  font-size: 13px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  white-space: nowrap;
  flex-shrink: 0;

  @media (max-width: 768px) {
    padding: 6px 12px;
    font-size: 11px;
  }

  @media (max-width: 480px) {
    padding: 4px 10px;
    font-size: 10px;
  }
`;

export const InfoGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 20px;
  margin-bottom: 20px;

  @media (max-width: 1024px) {
    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
    gap: 16px;
  }

  @media (max-width: 768px) {
    grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
    gap: 12px;
  }

  @media (max-width: 480px) {
    grid-template-columns: 1fr;
    gap: 10px;
  }
`;

export const InfoCard = styled.div`
  background: rgba(255, 255, 255, 0.1);
  border-radius: 10px;
  padding: 16px;
  backdrop-filter: blur(10px);

  @media (max-width: 768px) {
    padding: 12px;
    border-radius: 8px;
  }

  @media (max-width: 480px) {
    padding: 10px;
    border-radius: 6px;
  }
`;

export const InfoLabel = styled.div`
  color: rgba(255, 255, 255, 0.7);
  font-size: 13px;
  font-weight: 500;
  margin-bottom: 6px;
  display: flex;
  align-items: center;
  gap: 8px;

  i {
    font-size: 14px;
    flex-shrink: 0;
  }

  @media (max-width: 768px) {
    font-size: 12px;
    margin-bottom: 4px;
    gap: 6px;

    i {
      font-size: 12px;
    }
  }

  @media (max-width: 480px) {
    font-size: 11px;
    margin-bottom: 3px;
    gap: 4px;

    i {
      font-size: 10px;
    }
  }
`;

export const InfoValue = styled.div`
  color: white;
  font-size: 16px;
  font-weight: 600;
  word-break: break-word;

  @media (max-width: 1024px) {
    font-size: 14px;
  }

  @media (max-width: 768px) {
    font-size: 13px;
  }

  @media (max-width: 480px) {
    font-size: 12px;
  }
`;

export const DocumentLink = styled.a`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  color: #f9ae17;
  text-decoration: none;
  font-weight: 500;
  padding: 10px 16px;
  background: rgba(249, 174, 23, 0.15);
  border-radius: 8px;
  transition: all 0.2s ease;
  font-size: 14px;
  margin-right: 10px;

  &:hover {
    background: rgba(249, 174, 23, 0.25);
    transform: translateY(-2px);
  }

  i {
    font-size: 18px;
    flex-shrink: 0;
  }

  @media (max-width: 768px) {
    padding: 8px 12px;
    font-size: 12px;
    gap: 6px;
    margin-right: 0;

    i {
      font-size: 16px;
    }
  }

  @media (max-width: 480px) {
    padding: 6px 10px;
    font-size: 11px;
    gap: 4px;
    margin-right: 0;

    i {
      font-size: 14px;
    }
  }
`;

export const AttendeeSection = styled.div`
  background: white;
  border-radius: 16px;
  padding: 24px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);

  @media (max-width: 768px) {
    padding: 16px;
    border-radius: 12px;
  }

  @media (max-width: 480px) {
    padding: 12px;
    border-radius: 8px;
  }
`;

export const SectionHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  padding-bottom: 16px;
  border-bottom: 2px solid #f1f5f9;
  flex-wrap: wrap;
  gap: 10px;

  @media (max-width: 768px) {
    margin-bottom: 16px;
    padding-bottom: 12px;
  }

  @media (max-width: 480px) {
    margin-bottom: 12px;
    padding-bottom: 10px;
  }
`;

export const SectionTitle = styled.h2`
  font-size: 20px;
  font-weight: 700;
  color: #203b34;
  margin: 0;
  display: flex;
  align-items: center;
  gap: 10px;

  i {
    font-size: 22px;
    flex-shrink: 0;
  }

  @media (max-width: 768px) {
    font-size: 18px;

    i {
      font-size: 20px;
    }
  }

  @media (max-width: 480px) {
    font-size: 16px;
    gap: 8px;

    i {
      font-size: 18px;
    }
  }
`;

export const TotalParticipants = styled.div`
  background: #203b34;
  color: white;
  padding: 8px 20px;
  border-radius: 20px;
  font-size: 14px;
  font-weight: 600;

  strong {
    font-size: 18px;
    margin-left: 8px;
  }

  @media (max-width: 768px) {
    padding: 6px 16px;
    font-size: 12px;

    strong {
      font-size: 16px;
      margin-left: 6px;
    }
  }

  @media (max-width: 480px) {
    padding: 5px 12px;
    font-size: 11px;

    strong {
      font-size: 14px;
      margin-left: 4px;
    }
  }
`;

export const AttendeeGrid = styled.div`
  /* Wrapper for InfiniteList */

  .attendees-infinite-scroll {
    display: grid !important;
    grid-template-columns: repeat(auto-fill, minmax(350px, 1fr));
    gap: 16px;

    @media (max-width: 1024px) {
      grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
      gap: 14px;
    }

    @media (max-width: 768px) {
      grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
      gap: 12px;
    }

    @media (max-width: 600px) {
      grid-template-columns: 1fr;
      gap: 12px;
    }

    @media (max-width: 480px) {
      grid-template-columns: 1fr;
      gap: 10px;
    }
  }

  /* Ocultar elementos innecesarios del InfiniteList */
  .row h5 {
    display: none;
  }

  /* Ajustar el contenedor del SwipeableList */
  .swipeable-list {
    display: contents;
  }

  .swipeable-list-item {
    display: contents;
  }
`;

export const AttendeeCard = styled.div`
  background: ${(props) => (props.$signed ? "#f0fdf4" : "#fefce8")};
  border: 2px solid ${(props) => (props.$signed ? "#86efac" : "#fde047")};
  border-radius: 12px;
  padding: 16px;
  display: flex;
  align-items: center;
  gap: 16px;
  transition: all 0.2s ease;
  position: relative;
  flex-wrap: wrap;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  }

  @media (max-width: 768px) {
    padding: 12px;
    gap: 12px;
    border-radius: 10px;
  }

  @media (max-width: 480px) {
    padding: 10px;
    gap: 10px;
    border-radius: 8px;
    flex-direction: column;
    align-items: center;
    text-align: center;
  }
`;

export const AttendeeAvatar = styled.div`
  width: 50px;
  height: 50px;
  background: ${(props) => (props.$signed ? "#22c55e" : "#eab308")};
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 20px;
  flex-shrink: 0;

  @media (max-width: 768px) {
    width: 45px;
    height: 45px;
    font-size: 18px;
  }

  @media (max-width: 480px) {
    width: 40px;
    height: 40px;
    font-size: 16px;
  }
`;

export const AttendeeInfo = styled.div`
  flex: 1;
  min-width: 0;

  @media (max-width: 480px) {
    width: 100%;
  }
`;

export const AttendeeName = styled.div`
  font-size: 15px;
  font-weight: 600;
  color: #1e293b;
  margin-bottom: 4px;
  white-space: normal;
  word-break: break-word;
  text-overflow: ellipsis;

  @media (max-width: 768px) {
    font-size: 14px;
    margin-bottom: 2px;
  }

  @media (max-width: 480px) {
    font-size: 13px;
  }
`;

export const AttendeeId = styled.div`
  font-size: 13px;
  color: #64748b;
  font-weight: 500;
  word-break: break-word;

  @media (max-width: 768px) {
    font-size: 12px;
  }

  @media (max-width: 480px) {
    font-size: 11px;
  }
`;

export const AttendeeActions = styled.div`
  display: flex;
  gap: 8px;
  flex-shrink: 0;

  @media (max-width: 480px) {
    width: 100%;
    justify-content: center;
    gap: 6px;
  }
`;

export const ActionButton = styled.button`
  width: 36px;
  height: 36px;
  border-radius: 8px;
  border: none;
  background: ${(props) => {
    if (props.$variant === "sign") return "#f9ae17";
    if (props.$variant === "delete") return "#ef4444";
    return "#64748b";
  }};
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.2s ease;
  font-size: 16px;
  flex-shrink: 0;

  &:hover {
    transform: scale(1.1);
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
    &:hover {
      transform: none;
      box-shadow: none;
    }
  }

  @media (max-width: 768px) {
    width: 32px;
    height: 32px;
    font-size: 14px;
    border-radius: 6px;
  }

  @media (max-width: 480px) {
    width: 30px;
    height: 30px;
    font-size: 12px;
  }
`;

export const SignedBadge = styled.div`
  position: absolute;
  top: 8px;
  right: 8px;
  background: #22c55e;
  color: white;
  padding: 4px 10px;
  border-radius: 12px;
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  display: flex;
  align-items: center;
  gap: 4px;

  i {
    font-size: 10px;
  }

  @media (max-width: 768px) {
    top: 6px;
    right: 6px;
    padding: 3px 8px;
    font-size: 10px;
  }

  @media (max-width: 480px) {
    top: 4px;
    right: 4px;
    padding: 2px 6px;
    font-size: 9px;
  }
`;

export const ActionsBar = styled.div`
  background: white;
  border-radius: 16px;
  padding: 24px;
  margin-top: 24px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
  display: flex;
  gap: 16px;
  justify-content: center;
  flex-wrap: wrap;

  @media (max-width: 1024px) {
    padding: 20px;
    gap: 12px;
  }

  @media (max-width: 768px) {
    padding: 16px;
    gap: 10px;
    margin-top: 16px;
    border-radius: 12px;
  }

  @media (max-width: 480px) {
    padding: 12px;
    gap: 8px;
    margin-top: 12px;
    border-radius: 8px;
    flex-direction: column;
  }
`;

export const PrimaryButton = styled.button`
  background: #203b34;
  color: white;
  border: none;
  border-radius: 10px;
  padding: 14px 32px;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 10px;
  transition: all 0.2s ease;
  white-space: nowrap;

  i {
    font-size: 18px;
    flex-shrink: 0;
  }

  &:hover {
    background: #2d5245;
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(32, 59, 52, 0.3);
  }

  @media (max-width: 768px) {
    padding: 10px 20px;
    font-size: 13px;
    gap: 8px;
    border-radius: 8px;

    i {
      font-size: 16px;
    }
  }

  @media (max-width: 480px) {
    width: 100%;
    padding: 12px 16px;
    font-size: 12px;
    justify-content: center;
  }
`;

export const SecondaryButton = styled.button`
  background: transparent;
  color: #64748b;
  border: 2px solid #e2e8f0;
  border-radius: 10px;
  padding: 14px 32px;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 10px;
  transition: all 0.2s ease;
  white-space: nowrap;

  i {
    font-size: 18px;
    flex-shrink: 0;
  }

  &:hover {
    background: #f8fafc;
    border-color: #cbd5e1;
    transform: translateY(-2px);
  }

  @media (max-width: 768px) {
    padding: 10px 20px;
    font-size: 13px;
    gap: 8px;
    border-radius: 8px;

    i {
      font-size: 16px;
    }
  }

  @media (max-width: 480px) {
    width: 100%;
    padding: 12px 16px;
    font-size: 12px;
    justify-content: center;
  }
`;

export const CreateButton = styled.button`
  color: #203b34;
  background: #f9ae17;
  border: 2px solid #ad7a15;
  border-radius: 10px;
  padding: 14px 32px;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 10px;
  transition: all 0.2s ease;
  white-space: nowrap;
  flex-shrink: 0;

  i {
    font-size: 18px;
    flex-shrink: 0;
  }

  &:hover {
    background: #f8fafc;
    border-color: #cbd5e1;
    transform: translateY(-2px);
  }

  @media (max-width: 1024px) {
    padding: 12px 24px;
    font-size: 13px;
    gap: 8px;
    border-radius: 8px;

    i {
      font-size: 16px;
    }
  }

  @media (max-width: 768px) {
    padding: 10px 16px;
    font-size: 12px;
    gap: 6px;
    border-radius: 6px;

    i {
      font-size: 14px;
    }
  }

  @media (max-width: 480px) {
    width: 100%;
    padding: 10px 12px;
    font-size: 11px;
    gap: 6px;
    border-radius: 6px;
    justify-content: center;

    i {
      font-size: 12px;
    }
  }
`;

export const EmptyState = styled.div`
  text-align: center;
  padding: 60px 20px;
  color: #94a3b8;

  i {
    font-size: 64px;
    margin-bottom: 20px;
    opacity: 0.5;
  }

  p {
    font-size: 16px;
    font-weight: 500;
  }
`;

// Pagination Styles
export const PaginationContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 30px;
  padding: 20px;
  background: white;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);

  @media (max-width: 768px) {
    flex-direction: column;
    gap: 15px;
  }
`;

export const PaginationInfo = styled.div`
  color: #64748b;
  font-size: 14px;
`;

export const PaginationButtons = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;

  span {
    color: #94a3b8;
    padding: 0 8px;
  }
`;

export const PageButton = styled.button`
  min-width: 36px;
  height: 36px;
  background: ${(props) => (props.$active ? "#203b34" : "white")};
  color: ${(props) => (props.$active ? "white" : "#64748b")};
  border: 1px solid ${(props) => (props.$active ? "#203b34" : "#e2e8f0")};
  border-radius: 6px;
  padding: 8px 12px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;

  &:hover:not(:disabled) {
    background: ${(props) => (props.$active ? "#152820" : "#f8fafc")};
    border-color: ${(props) => (props.$active ? "#152820" : "#cbd5e1")};
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }

  i {
    font-size: 12px;
  }
`;

export const FormContainer = styled.div`
  width: 100%;
  margin: 0 auto;
  background: #fff;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
`;

export const Header2 = styled.div`
  background: linear-gradient(135deg, #2c3e35 0%, #1a2822 100%);
  padding: 2rem 2.5rem;
  color: #fff;
`;

export const HeaderTitle = styled.h1`
  font-size: 1.75rem;
  font-weight: 600;
  margin: 0 0 0.5rem 0;
  color: #fff;
`;

export const HeaderSubtitle = styled.p`
  font-size: 0.95rem;
  margin: 0;
  color: rgba(255, 255, 255, 0.85);
  font-weight: 400;
`;

export const FormBody = styled.div`
  padding: 2.5rem;
`;

export const FormSection = styled.div`
  margin-bottom: 2rem;

  .form-control,
  .input-wrapper {
    width: 100%;
  }
`;

export const SectionLabel = styled.label`
  display: block;
  font-size: 0.95rem;
  font-weight: 600;
  color: #2c3e35;
  margin-bottom: 0.5rem;

  ${(props) =>
    props.mandatory &&
    `
    &::after {
      content: " *";
      color: #dc3545;
    }
  `}
`;

export const HelpText = styled.p`
  font-size: 0.85rem;
  color: #6c757d;
  margin: 0.5rem 0;
  display: flex;
  align-items: center;
  gap: 0.5rem;

  i {
    color: #f9ae17;
  }
`;

export const LocationsContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr auto 1fr;
  gap: 1rem;
  margin-top: 1rem;
  margin-bottom: 1rem;
`;

export const LocationPanel = styled.div`
  border: 1px solid #dee2e6;
  border-radius: 6px;
  /* overflow: hidden; */
  background: #fff;
`;

export const PanelHeader = styled.div`
  background: #f8f9fa;
  padding: 0.75rem 1rem;
  border-bottom: 1px solid #dee2e6;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-weight: 500;
  color: #495057;
  font-size: 0.9rem;
`;

export const ItemCount = styled.span`
  background: ${(props) => (props.selected ? "#f9ae17" : "#6c757d")};
  color: #fff;
  padding: 0.2rem 0.6rem;
  border-radius: 12px;
  font-size: 0.75rem;
  font-weight: 600;
`;

export const SearchBox = styled.div`
  padding: 0.75rem 1rem;
  border-bottom: 1px solid #dee2e6;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  background: #fff;

  i {
    color: #6c757d;
    font-size: 0.9rem;
  }

  .search-input {
    border: none;
    outline: none;
    flex: 1;
    font-size: 0.9rem;
    color: #495057;
    background: transparent;

    &::placeholder {
      color: #adb5bd;
    }
  }
`;

export const LocationList = styled.div`
  height: 300px;
  overflow-y: auto;
  overflow-x: hidden;

  .no-items,
  .no-items-selected {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    color: #adb5bd;
    font-size: 0.9rem;
    text-align: center;
    padding: 2rem;
  }

  /* Scrollbar styling */
  &::-webkit-scrollbar {
    width: 8px;
  }

  &::-webkit-scrollbar-track {
    background: #f8f9fa;
  }

  &::-webkit-scrollbar-thumb {
    background: #cbd5e0;
    border-radius: 4px;

    &:hover {
      background: #a0aec0;
    }
  }
`;

export const LocationItem = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0.75rem 1rem;
  border-bottom: 1px solid #f1f3f5;
  font-size: 0.9rem;
  color: #495057;
  transition: background-color 0.15s ease;
  cursor: pointer;
  user-select: none;

  &:hover {
    background-color: #f8f9fa;
  }

  &:active {
    background-color: #e9ecef;
  }

  &:last-child {
    border-bottom: none;
  }

  span {
    flex: 1;
  }

  .action-btn {
    background: transparent;
    border: none;
    color: #6c757d;
    cursor: pointer;
    padding: 0.25rem 0.5rem;
    font-size: 0.85rem;
    transition: color 0.15s ease;

    &:hover {
      color: #f9ae17;
    }
  }
`;

export const TransferButtons = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 0.5rem;
  padding: 1rem 0;
`;

export const TransferButton = styled.button`
  background: #fff;
  border: 1px solid #dee2e6;
  border-radius: 6px;
  padding: 0.5rem 0.75rem;
  cursor: pointer;
  color: #495057;
  transition: all 0.15s ease;
  font-size: 1rem;

  &:hover:not(:disabled) {
    background: #f9ae17;
    border-color: #f9ae17;
    color: #fff;
    transform: scale(1.05);
  }

  &:disabled {
    opacity: 0.4;
    cursor: not-allowed;
  }

  i {
    display: block;
  }
`;

export const ButtonsContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 1rem;
  margin-bottom: 2rem;
`;

export const CancelButton = styled.button`
  background: #6c757d;
  color: #fff;
  border: none;
  border-radius: 6px;
  padding: 1rem 2rem;
  font-size: 1.05rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  min-width: 150px;

  &:hover {
    background: #5a6268;
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(108, 117, 125, 0.3);
  }

  &:active {
    transform: translateY(0);
  }
`;

export const ActionButton2 = styled.button`
  background: #f9ae17;
  color: #2c3e35;
  border: none;
  border-radius: 6px;
  padding: 1rem 2rem;
  font-size: 1.05rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  min-width: 200px;

  &:hover {
    background: #e89d0f;
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(249, 174, 23, 0.3);
  }

  &:active {
    transform: translateY(0);
  }
`;

export const AttendeeGridNotSigned = styled.div`
  /* Grid por defecto para elementos renderizados directamente */
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(350px, 1fr));
  gap: 16px;

  @media (max-width: 1024px) {
    grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
    gap: 14px;
  }

  @media (max-width: 768px) {
    grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
    gap: 12px;
  }

  @media (max-width: 600px) {
    grid-template-columns: 1fr;
    gap: 12px;
  }

  @media (max-width: 480px) {
    grid-template-columns: 1fr;
    gap: 10px;
  }

  /* Ajustar el contenedor del SwipeableList */
  .swipeable-list {
    display: contents;
  }

  .swipeable-list-item {
    display: contents;
  }
`;
